import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useBrandContext } from '../../context/BrandContext';
import { useToast } from '../../context/ToastModalContext';
import Button from '../../components/button/Button';
import HeaderBasicLayout from '../../components/header/headerBasicLayout/HeaderBasicLayout';
import { getOrderData } from '../../services/extractService';
import check from '../../assets/check_circle.svg';
import checkGreen from '../../assets/payments/check_circle-green.svg';
import contentCopy from '../../assets/content_copy.svg';
import contentCopyBlack from '../../assets/content_copy_black.svg';
import { ReactComponent as LoaderSecondary } from '../../assets/SpinnerBlack.svg';
import { IOrderData } from '../../shared/models/orderData/orderData';
import { formatDateWalletHistory } from '../../utils/format';
import './Pix.css';
import { useHeaderContext } from '../../context/HeaderContext';

const Pix: React.FC = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [orderData, setOrderData] = useState<IOrderData>();
  const navigate = useNavigate();
  const { orderId } = useParams();
  const location = useLocation();

  const brandContext = useBrandContext();
  const { setHeaderConfig } = useHeaderContext();
  // const routePaths = location.pathname.split('/');

  //toast
  const { showToast } = useToast();

  const backNavigation = useCallback(() => {
    navigate(`/${brandContext.brandName}/paymentMethods`);
  }, [brandContext.brandName, navigate]);

  useEffect(() => {
    if (orderId) {
      getOrderDataPix(orderId);
    }
  }, []);

  const getOrderDataPix = async (id: string) => {
    if (id) {
      try {
        setIsLoading(true);
        const response = await getOrderData(id);
        setIsError(false);
        const orderPaymentMethodData = JSON.parse(
          response.orderPaymentMethodData
        );
        const orderData = JSON.parse(response.orderData);
        const orderDataValue: IOrderData = {
          amount: response?.orderAmount,
          cardInfo: orderPaymentMethodData.description,
          date: formatDateWalletHistory(
            new Date(orderData?.due_date)
          ).substring(0, 10),
          authorizationCod: response.orderInvoiceId,
          item_type: orderPaymentMethodData.item_type,
          qrCodeText: orderData?.pix?.qrcode_text,
        };
        setOrderData(orderDataValue);
        setIsLoading(false);
      } catch (er) {
        setIsLoading(false);
        setIsError(true);
        showToast({
          title: 'Ocorreu um erro',
          messageModal: 'Ocorreu um erro ao gerar o código PIX',
          textEnterButton: 'Fechar',
          allowButtonClosed: false,
          handleEnterButton: () => backNavigation(),
        });
        console.log(er);
      }
    }
  };

  const handleCopyPixCode = async () => {
    if (orderData?.qrCodeText) {
      setIsChecked(true);
      navigator.clipboard.writeText(orderData?.qrCodeText!);
      setTimeout(() => {
        setIsChecked(false);
      }, 2000);
    }
  };

  useEffect(() => {
    setHeaderConfig({
      headerText: 'Cartão de crédito',
      backNavigation: () => backNavigation(),
    });
    return () => setHeaderConfig({});
  }, [backNavigation, navigate, setHeaderConfig]);

  return (
    <>
      {!isLoading && orderData ? (
        <div className='pix-content-container'>
          <b className='pix-content-title'>Adicione R$ {orderData?.amount}</b>
          <b className='pix-content-subtitle'>
            Para concluir o pagamento via Pix:
          </b>
          <div className='pix-content-steps-container'>
            <p className='pix-content-steps'>1. Copie o código Pix:</p>
            <Button
              type='button'
              children={
                <p className='pix-key-value'>{orderData?.qrCodeText}</p>
              }
              disabled={isChecked}
              onClick={handleCopyPixCode}
              style={{
                marginTop: '5px',
                marginBottom: '10px',
                color: '#787E7D',
                fontSize: '10px',
                paddingRight: '20px',
                backgroundColor: 'transparent',
                border: '1px solid #787E7D',
              }}
              image={
                <img
                  width='20px'
                  height='20px'
                  alt='add-button-icon'
                  src={isChecked ? checkGreen : contentCopyBlack}
                />
              }
            />
            <p className='pix-content-steps'>
              2. Abra o aplicativo do seu banco, selecione "Pix" e depois "Pix
              copia e cola".
            </p>
            <p className='pix-content-steps'>
              3. Cole o código, confira se as informações estão corretas e
              confirme o pagamento.
            </p>
          </div>

          <span className='pix-content-validate'>
            Este código é válido até a data <b>{orderData?.date}</b>.
          </span>

          <Button
            type='button'
            children='Copiar código PIX'
            disabled={isChecked}
            onClick={handleCopyPixCode}
            style={{
              marginTop: '13px',
              backgroundColor: brandContext.brandBgColor,
            }}
            image={
              <img
                width='20px'
                height='20px'
                alt='add-button-icon'
                src={isChecked ? check : contentCopy}
              />
            }
          />
        </div>
      ) : (
        isLoading && <LoaderSecondary />
      )}
    </>
  );
};

export default Pix;
